import { PromotionListTable, PromotionListPageHeader } from './components';

function PromotionList() {
  return (
    <div className="p-10">
      <PromotionListPageHeader />
      <PromotionListTable />
    </div>
  );
}

export default PromotionList;
